export default {
  buttonTitle: {
    en: 'Copy referral link',
  },
  buttonTitleShort: {
    en: 'Copy link',
  },
  copied: {
    en: 'Copied',
  },
}
